// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --page-width: 11in;
  --page-height: 8.5in;
  --footer-height: 0.5in;
  --header-height: 0.8in;
}

body {
  margin: 0;
  padding: 0;
  background-color: #eee;
  font-family: "Open Sans", Arial, sans-serif;
}

/* Scrollable Container for Preview */
.print-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  gap: 20px;
}

.backbutton-sticky {
  position: fixed !important;
  top: 16px;
  right: 16px;
  z-index: 1000;
}

/* Page Dimensions & Outer Box */
.print-page-landscape {
  width: var(--page-width);
  height: var(--page-height);
  background: #ffffff;
  box-sizing: border-box;
  padding: 0.4in 0.5in;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  page-break-after: always;
}

/* Back Button */
.backbutton {
  position: absolute !important;
  top: 12px;
  right: 12px;
  z-index: 100;
}

/* Main Inner Wrapper */
.page-content-landscape {
  display: flex;
  flex-direction: column;
  height: calc(var(--page-height) - var(--footer-height) - 0.8in);
  width: 100%;
}

/* Header Row */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #000;
  padding-bottom: 4px;
  margin-bottom: 8px;
}

.doc-title-ls {
  font-size: 22px;
  font-weight: 800;
  margin: 0;
  color: #000;
  text-transform: uppercase;
}

.page-number-text {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}

/* Subheader Instruction Bar */
.instruction-text-ls {
  font-size: 10px;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

/* 3-Column Workspace Grid */
.landscape-grid {
  display: flex;
  flex: 1 1;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-height: 0; /* Prevents overflow collapse */
}

/* Left Column: Data Table */
.grid-left {
  /* Change flex-basis or allow it to grow. 
     Use a larger fixed basis (e.g., 420px) OR allow flex-growth: */
  flex: 0 0 320px; /* Increased from 320px to allocate more dedicated space */
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}

.table-wrapper {
  border: 1px solid #ccc;
  width: 100% !important; /* Force wrapper to stretch completely */
  height: 100%;
  box-sizing: border-box;
}

/* Force MUI Table to fill 100% width of grid-left */
.table-wrapper .MuiTable-root {
  width: 100% !important;
  table-layout: fixed; /* Ensures clean column distribution */
}

/* Optional: Evenly space table cells across the expanded table */
.table-wrapper .MuiTableCell-root {
  padding: 4px 2px !important;
  text-align: center;
}

/* Center Column Flex Container */
.grid-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

/* Wrapper establishes strict percentage bounds for the image */
.main-image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Base Image Sizing */
.main-step-image {
  object-fit: contain;
}

/* Adjust percentages here — changes will now immediately scale the image! */
.main-step-image.isu-diagram {
  width: 275%;
  height: 275%;
  transform: translate(30px,90px);
}

.main-step-image.pallet-diagram {
  width: 258%;
  height: 258%;
  transform: translate(-150px,50px);
}

/* Right Column: Stacked Isometric & Overhead Views */
.grid-right {
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}

.sidebar-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.card-label {
  font-size: 10px;
  font-weight: 700;
  color: #000;
  margin-bottom: 4px;
  text-align: center;
}

.card-image-box {
  width: 180px;
  height: 160px;
  border: 1.5px solid #222;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  overflow: hidden;
}

.card-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-image.isu-card-img {
  max-width: 135%;
  max-height: 135%;
  transform: translateX(35px);
  object-fit: contain;
}

.card-image.pallet-card-img {
  max-width: 155%;
  max-height: 155%;
  transform: translate(40px,0px);
  object-fit: contain;
}

.card-image-1 {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-image-1.isu-card-img {
  max-width: 145%;
  max-height: 145%;
  transform: translateY(30px);
  object-fit: contain;
}

.card-image-1.pallet-card-img {
  max-width: 215%;
  max-height: 215%;
  transform: translateX(-50px);
  object-fit: contain;
}

/* Footer Guide Section */
.page-footer-ls {
  height: var(--footer-height);
  border-top: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding-top: 4px;
}

.guide-title {
  font-weight: 800;
  font-size: 10px;
  color: #000;
}

.footer-object {
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer-text {
  font-size: 9px;
  color: #222;
}

.footer-img-grey {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.bold {
  font-weight: 700;
  font-size: 10px;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 16px;
  font-weight: 600;
}

/* Print Specific Media Queries */
@media print {
  body {
    background: none;
  }
  .print-root {
    padding: 0;
    gap: 0;
  }
  .print-page-landscape {
    box-shadow: none;
    margin: 0;
  }
  .backbutton {
    display: none !important;
  }
}

.door-label {
  position: absolute;
  right: 80px;           /* Inset from the right edge */
  bottom: 40px;          /* Inset from the bottom edge */
  transform: rotate(-45deg);
  transform-origin: center;
  
  font-weight: 700;
  font-size: 23px;
  color: #000000;
  white-space: nowrap;
  pointer-events: none;  /* Lets clicks pass through to the image if needed */
  z-index: 2;            /* Keeps text layered above the image */
}

/* Fallback Screen for Empty Containers */
.no-boxes-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
  position: relative;
}

.no-boxes-card {
  background: #ffffff;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #e0e0e0;
}

.no-boxes-card h2 {
  font-size: 22px;
  font-weight: 700;
  color: #333333;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/containers/LandscapePrintout/landscape.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,+DAA+D;EAC/D,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa,EAAE,+BAA+B;AAChD;;AAEA,4BAA4B;AAC5B;EACE;mEACiE;EACjE,eAAe,EAAE,0DAA0D;EAC3E,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB,EAAE,wCAAwC;EAChE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA,iEAAiE;AACjE;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,MAAM;EACR;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW,YAAY,8BAA8B;EACrD,YAAY,WAAW,+BAA+B;EACtD,yBAAyB;EACzB,wBAAwB;;EAExB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB,GAAG,oDAAoD;EAC3E,UAAU,aAAa,uCAAuC;AAChE;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX","sourcesContent":[":root {\n  --page-width: 11in;\n  --page-height: 8.5in;\n  --footer-height: 0.5in;\n  --header-height: 0.8in;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: #eee;\n  font-family: \"Open Sans\", Arial, sans-serif;\n}\n\n/* Scrollable Container for Preview */\n.print-root {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0;\n  gap: 20px;\n}\n\n.backbutton-sticky {\n  position: fixed !important;\n  top: 16px;\n  right: 16px;\n  z-index: 1000;\n}\n\n/* Page Dimensions & Outer Box */\n.print-page-landscape {\n  width: var(--page-width);\n  height: var(--page-height);\n  background: #ffffff;\n  box-sizing: border-box;\n  padding: 0.4in 0.5in;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  page-break-after: always;\n}\n\n/* Back Button */\n.backbutton {\n  position: absolute !important;\n  top: 12px;\n  right: 12px;\n  z-index: 100;\n}\n\n/* Main Inner Wrapper */\n.page-content-landscape {\n  display: flex;\n  flex-direction: column;\n  height: calc(var(--page-height) - var(--footer-height) - 0.8in);\n  width: 100%;\n}\n\n/* Header Row */\n.header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #000;\n  padding-bottom: 4px;\n  margin-bottom: 8px;\n}\n\n.doc-title-ls {\n  font-size: 22px;\n  font-weight: 800;\n  margin: 0;\n  color: #000;\n  text-transform: uppercase;\n}\n\n.page-number-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: #000;\n}\n\n/* Subheader Instruction Bar */\n.instruction-text-ls {\n  font-size: 10px;\n  color: #333;\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n/* 3-Column Workspace Grid */\n.landscape-grid {\n  display: flex;\n  flex: 1;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n  min-height: 0; /* Prevents overflow collapse */\n}\n\n/* Left Column: Data Table */\n.grid-left {\n  /* Change flex-basis or allow it to grow. \n     Use a larger fixed basis (e.g., 420px) OR allow flex-growth: */\n  flex: 0 0 320px; /* Increased from 320px to allocate more dedicated space */\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.table-wrapper {\n  border: 1px solid #ccc;\n  width: 100% !important; /* Force wrapper to stretch completely */\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* Force MUI Table to fill 100% width of grid-left */\n.table-wrapper .MuiTable-root {\n  width: 100% !important;\n  table-layout: fixed; /* Ensures clean column distribution */\n}\n\n/* Optional: Evenly space table cells across the expanded table */\n.table-wrapper .MuiTableCell-root {\n  padding: 4px 2px !important;\n  text-align: center;\n}\n\n/* Center Column Flex Container */\n.grid-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  background-color: #fafafa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Wrapper establishes strict percentage bounds for the image */\n.main-image-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Base Image Sizing */\n.main-step-image {\n  object-fit: contain;\n}\n\n/* Adjust percentages here — changes will now immediately scale the image! */\n.main-step-image.isu-diagram {\n  width: 275%;\n  height: 275%;\n  transform: translate(30px,90px);\n}\n\n.main-step-image.pallet-diagram {\n  width: 258%;\n  height: 258%;\n  transform: translate(-150px,50px);\n}\n\n/* Right Column: Stacked Isometric & Overhead Views */\n.grid-right {\n  flex: 0 0 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.sidebar-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.card-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.card-image-box {\n  width: 180px;\n  height: 160px;\n  border: 1.5px solid #222;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #fff;\n  overflow: hidden;\n}\n\n.card-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.card-image.isu-card-img {\n  max-width: 135%;\n  max-height: 135%;\n  transform: translateX(35px);\n  object-fit: contain;\n}\n\n.card-image.pallet-card-img {\n  max-width: 155%;\n  max-height: 155%;\n  transform: translate(40px,0px);\n  object-fit: contain;\n}\n\n.card-image-1 {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.card-image-1.isu-card-img {\n  max-width: 145%;\n  max-height: 145%;\n  transform: translateY(30px);\n  object-fit: contain;\n}\n\n.card-image-1.pallet-card-img {\n  max-width: 215%;\n  max-height: 215%;\n  transform: translateX(-50px);\n  object-fit: contain;\n}\n\n/* Footer Guide Section */\n.page-footer-ls {\n  height: var(--footer-height);\n  border-top: 1px solid #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  padding-top: 4px;\n}\n\n.guide-title {\n  font-weight: 800;\n  font-size: 10px;\n  color: #000;\n}\n\n.footer-object {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.footer-text {\n  font-size: 9px;\n  color: #222;\n}\n\n.footer-img-grey {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.bold {\n  font-weight: 700;\n  font-size: 10px;\n}\n\n.loading-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n/* Print Specific Media Queries */\n@media print {\n  body {\n    background: none;\n  }\n  .print-root {\n    padding: 0;\n    gap: 0;\n  }\n  .print-page-landscape {\n    box-shadow: none;\n    margin: 0;\n  }\n  .backbutton {\n    display: none !important;\n  }\n}\n\n.door-label {\n  position: absolute;\n  right: 80px;           /* Inset from the right edge */\n  bottom: 40px;          /* Inset from the bottom edge */\n  transform: rotate(-45deg);\n  transform-origin: center;\n  \n  font-weight: 700;\n  font-size: 23px;\n  color: #000000;\n  white-space: nowrap;\n  pointer-events: none;  /* Lets clicks pass through to the image if needed */\n  z-index: 2;            /* Keeps text layered above the image */\n}\n\n/* Fallback Screen for Empty Containers */\n.no-boxes-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: #f5f5f5;\n  position: relative;\n}\n\n.no-boxes-card {\n  background: #ffffff;\n  padding: 40px 60px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border: 1px solid #e0e0e0;\n}\n\n.no-boxes-card h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #333333;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
